// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120521/js/" + chunkId + "." + {"44":"3595c376","225":"2425df15","481":"6a991695","486":"7e29b369","770":"c75d4d42"}[chunkId] + ".0.9025870024156398.chunk.js";
};